import React from 'react';
import {
  FormControl,
  Box,
  FormHelperText,
  TextField,
} from '@mui/material';

export default function InputEndpointUrlField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  inputType,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);

    const valid = /^https:\/\//.test(newValue);
    setError(!valid);
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Endpoint'
          id='input_endpoint_url'
          aria-describedby='input-endpoint-url-helper-text'
          variant='outlined'
          fullWidth
          placeholder='https://s3.wasabisys.com'
          onChange={handleChange}
          error={Boolean(error)}
          value={value || ''}
          disabled={!inputType || edit}
        />
        {error ? (
          <FormHelperText id='input-endpoint-url-helper-text'>
            Endpoint Invalid
          </FormHelperText>
        ) : (
          <FormHelperText id='input-endpoint-url-helper-text'>
            Enter the endpoint URL
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

